<template>
  <div class="System">
    <h1>理论加工时间 </h1>
    <button v-on:click="add_click()">新增</button>
    <table border="3" width="1300px"> <!--border：表格边框，width：表格宽度-->
      <caption></caption> <!--标题标签，居中显示，仅有一个标题-->
      <tr>
        <th>id</th>
        <th>Programme ID</th>
        <th>加工时长</th>
        <th>产品ID</th>
        <th colspan="2">操作</th>
      </tr>
      <tr v-for="item in items">
        <td>
          <label> {{ item.id }}</label>
        </td>
        <td>
          <label> {{ item.programme_id }}</label>
        </td>
        <td>
          <label> {{ item.minutes }}</label>
        </td>
        <td>
          <label> {{ item.product_id }}</label>
        </td>
        <td>
          <button v-on:click="delete_click(item.id)">删除</button>
        </td>
        <td>
          <button v-on:click="edit_click(item)">编辑</button>
        </td>
      </tr>
    </table>
    <button v-on:click="add_click()">新增</button>
    <p>
      <button v-on:click="find_click()">查询</button>

    </p>

    <div class="dialog" v-if="showModal">

      <h1>新增 <button v-on:click="close_click()">关闭</button></h1>
 
      <p>
        <p>programme_id:</p>
      <input v-model="programme_id" placeholder="edit me" />

  

      <p>minutes:</p>
      <input v-model="minutes" placeholder="edit me" />

     

      <p>product_id:</p>
      <input v-model="product_id" placeholder="edit me" />

      </p>
      <button v-on:click="addNew()">提交</button>


    </div>

    <div class="dialogEdit" v-if="showEditModal">

      <h1>编辑 <button v-on:click="close_click()">关闭</button></h1>
      <p>Id:</p>
      <label> {{ id }} </label>


      <p>

      <p>programme_id:</p>
      <input v-model="programme_id" placeholder="edit me" />

  

      <p>minutes:</p>
      <input v-model="minutes" placeholder="edit me" />

     

      <p>product_id:</p>
      <input v-model="product_id" placeholder="edit me" />

      </p>
      <button v-on:click="update()">更新</button>


    </div>
  </div>
</template>


<script>
export default {
  name: 'about',

  data() {
    return {
      url:'http://192.168.132.65:8000/plan/manufacturetime/' ,
      showEditModal: false,
      showModal: false,
      refreshTime: '',
      id: '',
      minutes: '120',
      programme_id: '25_50_10_114.SPF' ,
      product_id: '16672686134620',
      item: { id: '6385810ef236bd2eede089f0', minutes: '120', programme_id: '25_50_10_114.SPF' ,product_id: '16672686134620'},
      items: [
       

      ]
    }
  },
  mounted() {
    let _this = this;
    this.$data.refreshTime = this.$cookies.get('refreshTime')
    this.find_click();

  },
  methods: {
    click() {
      this.$cookies.set('refreshTime', this.$data.refreshTime)
    },
    delete_click(id) {
      let _this = this;
      this.$http.delete(this.$data.url+ id)
        .then(function (response) {

          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);
          _this.find_click();
        })
        .catch(function (error) {
          console.log(error);
        });

      this.find_click();
    },
    add_click() {
      this.close_click();
      this.$data.showModal = true;
    },
    edit_click(item) {
      this.$data.id = item.id;
      this.$data.qty = item.qty;
      this.$data.productId = item.productId;

      this.close_click();
      this.$data.showEditModal = true;
    },
    find_click() {
      let _this = this;
      this.$http.get(this.$data.url)
        .then(function (response) {

          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);

          _this.$data.items = response.data.data;

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    close_click() {
      this.$data.showModal = false;
      this.$data.showEditModal = false;
    },
    addNew() {
      let _this = this;
      let minutes = _this.$data.minutes;
      let date = new Date();
      let programme_id = _this.$data.programme_id;
      let product_id = _this.$data.product_id;


      this.$http.post(this.$data.url, { minutes, programme_id, product_id })
        .then(function (response) {

          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);

          _this.find_click();
        })
        .catch(function (error) {
          console.log(error);
        });


    },
    update() {
      let _this = this;
      let id = _this.$data.id;
      let minutes = _this.$data.minutes;
      let programme_id = _this.$data.programme_id;
      let product_id = _this.$data.product_id;

      let date = new Date();

      this.$http.put(this.$data.url + id, { id, minutes,  programme_id ,product_id})
        .then(function (response) {

          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);
          _this.find_click();


        })
        .catch(function (error) {
          console.log(error);
        });

      this.find_click();
    }

  }
}
</script>

<style lang="less">
.dialog {
  box-sizing: border-box;
  width: 40%;
  background-color: rgba(197, 245, 199, 0.7);
  border-radius: 3px;

}

.dialogEdit {
  box-sizing: border-box;
  width: 40%;
  background-color: rgba(163, 178, 241, 0.7);
  border-radius: 3px;

}
</style>